<template>
      <v-card class="mx-auto" shaped elevation="7">
            <v-card-title>
                  Informe De Beneficio Complementario
            </v-card-title>
            <v-card-text>
                  <v-container fluid grid-list-sm>
                        <v-row dense>
                              <v-col cols="12">
                                    <ModalBeneficioAseguradoComponent :obModal="obModal" :listGeneral="listGeneral" />
                              </v-col>
                        </v-row>

                        <v-form ref="form">

                              <v-row dense>
                                    <v-col cols="12" sm="4">
                                          <v-dialog ref="dialogFechaDesde" v-model="objDate.desde.open"
                                                :return-value.sync="obSearch.fechaDesde" persistent width="340px">
                                                <template v-slot:activator="{ on }">
                                                      <v-text-field color="textbox" v-model="obSearch.fechaDesde"
                                                            label="Fecha Desde *" prepend-inner-icon="event" readonly
                                                            outlined dense v-on="on" :rules="requeridoRegla" />
                                                </template>
                                                <v-date-picker color="primary" v-model="obSearch.fechaDesde"
                                                      scrollable locale="es">
                                                      <v-spacer></v-spacer>
                                                      <v-btn outlined dense rounded color="danger"
                                                            @click="objDate.desde.open = false" v-html="'Salir'">
                                                      </v-btn>
                                                      <v-btn rounded dark color="primary"
                                                            @click="$refs.dialogFechaDesde.save(obSearch.fechaDesde);"
                                                            v-html="'Guardar Fecha'"></v-btn>
                                                </v-date-picker>
                                          </v-dialog>
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                          <v-dialog ref="dialogFechaHasta" v-model="objDate.hasta.open"
                                                :return-value.sync="obSearch.fechaHasta" persistent width="340px">
                                                <template v-slot:activator="{ on }">
                                                      <v-text-field color="textbox" v-model="obSearch.fechaHasta"
                                                            label="Fecha Hasta *" prepend-inner-icon="event" readonly
                                                            outlined dense v-on="on" :rules="requeridoRegla" />
                                                </template>
                                                <v-date-picker color="primary" v-model="obSearch.fechaHasta"
                                                      scrollable locale="es">
                                                      <v-spacer></v-spacer>
                                                      <v-btn outlined dense rounded color="danger"
                                                            @click="objDate.hasta.open = false" v-html="'Salir'">
                                                      </v-btn>
                                                      <v-btn rounded dark color="primary"
                                                            @click="$refs.dialogFechaHasta.save(obSearch.fechaHasta);"
                                                            v-html="'Guardar Fecha'"></v-btn>
                                                </v-date-picker>
                                          </v-dialog>
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                          <v-autocomplete label="Canal *" color="textbox"
                                                v-model="obSearch.idCanal" @change="onListarSeguro"
                                                :items="listGeneral.listCanal" 
                                                :rules="requeridoRegla" outlined dense />
                                    </v-col>
                              </v-row>

                              <v-row dense>
                                    <v-col cols="12" sm="4">
                                          <v-autocomplete label="Seguro *" color="textbox" v-model="obSearch.idSeguro"
                                                :items="listGeneral.listSeguro" outlined dense @change="onListarProducto"
                                                :rules="requeridoRegla"/>
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                          <v-autocomplete label="Producto *" color="textbox" v-model="obSearch.idProducto"
                                                :items="listGeneral.listProducto" outlined dense 
                                                :rules="requeridoRegla"/>
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                          <v-checkbox color="primary" label="Rango de Beneficios" v-model="check"></v-checkbox>
                                    </v-col>
                              </v-row>

                              <v-row dense>
                                    <v-col cols="12" sm="4">
                                          <v-text-field label="Rango de Valor de Beneficios Desde *" color="textbox" 
                                                        v-model="obSearch.rangoValorDesde" :rules="!check ? [] : _.concat(requeridoRegla,decimal)" outlined dense
                                                        :disabled="!check"/>
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                          <v-text-field label="Rango de Valor de Beneficios Hasta *" color="textbox" 
                                                        v-model="obSearch.rangoValorHasta" :rules="!check ? [] : _.concat(requeridoRegla,decimal)" outlined dense
                                                        :disabled="!check"/>
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                          <v-tooltip top color="primary">
                                                <template v-slot:activator="{ on }">
                                                      <v-btn fab dark small color="primary" @click="onListarCertificados" v-on="on"
                                                            :disabled="disabled">
                                                            <v-icon dark>search</v-icon>
                                                      </v-btn>
                                                </template>
                                                <span>Buscar</span>
                                          </v-tooltip>
                                    </v-col>
                              </v-row>

                        </v-form>

                        <v-row dense>
                              <v-col v-if="_.size(listGeneral.detalle) == 0" cols="12" sm="6"></v-col>
                              <v-col v-else cols="12" sm="6">
                                    <v-btn rounded color="primary" dark @click="exportar('tableBeneCom','Tasas')">Exportar a XLSX</v-btn>
                              </v-col>
                              <v-col cols="12" sm="6">
                                    <v-text-field label="Buscar" color="textbox" v-model="obSearch.search" clearable
                                    prepend-inner-icon="search" dense/>
                              </v-col>
                        </v-row>

                        <v-row dense>
                              <v-col cols="12">
                                    <v-data-table :search="obSearch.search" :headers="listGeneral.cabecera" id="tableBeneCom"
                                          :items="listGeneral.detalle" class="elevation-3" :group-by="isGroup ? ['producto'] : []">
                                    
                                    
                                          <template v-slot:item.asegurado="{ item }">
                                                <p :class="item.class">{{ item.asegurado }}</p>
                                          </template>
                                    
                                          <template v-slot:item.prima="{ item }">
                                                <p :class="item.class">{{ item.prima }}</p>
                                          </template>
                                    
                                          <template v-slot:item.comision="{ item }">
                                                <p :class="item.class">{{ item.comision }}</p>
                                          </template>
                                    
                                          <template v-slot:item.beneficio="{ item }">
                                                <p :class="item.class">{{ item.beneficio }}</p>
                                          </template>
                                    
                                          <template v-slot:item.costo="{ item }">
                                                <p :class="item.class">{{ item.costo }}</p>
                                          </template>
                                    
                                          <template v-slot:item.costoAsignado="{ item }">
                                                <p :class="item.class">{{ item.costoAsignado }}</p>
                                          </template>
                                    
                                          <template v-slot:item.name="{ item }">
                                                <v-btn v-show="_.size(item.idCertificado) > 0" class="ma-2" text icon color="primary" @click="ver(item)">
                                                      <v-icon small>visibility</v-icon>
                                                </v-btn>
                                          </template>
                                          
                                          <template v-slot:body.append>
                                                <tr v-show="_.size(listGeneral.detalle) > 0">
                                                      <td v-show="!isGroup"></td>
                                                      <td colspan="1"></td>
                                                      <td colspan="2"> <span class="font-weight-black" v-html="'Total'"></span></td>
                                                      <td><span class="font-weight-black" v-html="obTotal.totalPrima"> </span></td>
                                                      <td><span class="font-weight-black" v-html="obTotal.totalComision"> </span></td>
                                                      <td><span class="font-weight-black" v-html="obTotal.totalBeneficio"> </span></td>
                                                      <td><span class="font-weight-black" v-html="obTotal.totalCostoAsignado"> </span></td>
                                                      <td><span class="font-weight-black" v-html="obTotal.totalCosto"> </span></td>
                                                      <td></td>
                                                </tr>
                                          </template>

                                          <template v-slot:no-results>
                                                Tu búsqueda de "<span v-text="obSearch.search"></span>" no arrojó resultados.
                                          </template>
                                    </v-data-table>
                              </v-col>
                        </v-row>
                  </v-container>
            </v-card-text>
      </v-card>
</template>

<script>
      export default {
            name: 'InformeBeneficioComplementarioView',
            components:{
                  ModalBeneficioAseguradoComponent:() => import('@/components/beneficio/ModalBeneficioAseguradoComponent.vue')
            }, 
            data: () => ({
                  listGeneral:{},
                  parametros:{},
                  obSearch:{
                        search:'',
                        idCanal:null,
                        idProducto:null,
                        fechaDesde:moment().format('YYYY-MM-DD'),
                        fechaHasta:moment().format('YYYY-MM-DD'),
                        rangoValorDesde:null,
                        rangoValorHasta:null,
                        idEstado:null
                  },
                  objDate:{
                        desde:{open:false},
                        hasta:{open:false}
                  },
                  obTotal:{
                        totalPrima:0,
                        totalComision:0,
                        totalBeneficio:0,
                        totalCosto:0,
                        totalCostoAsignado:0,
                  },
                  obModal:{
                        titulo:'',
                        search:'',
                        open:false
                  },
                  disabled:false,
                  check:true,

            }),
            created(){
                  var error = 'E';

                  axios.post(`${BASE_URI}administrador/informe-beneficio-complementario/cargaGeneral`)
                        .then((r) =>{
                              if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                              if(_.size(_.get(r,['data','data'],[])) == 0) { error="I"; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion)};
                                    this.$set(this,'listGeneral', r.data.data.listas);
                                    this.$set(this,'parametros', r.data.data.parametros);
                                    this.obSearch.idEstado = _.toString(this.parametros.id_estado_default);
                                    this.listGeneral.listCanal = _.remove(this.listGeneral.listCanal,(v)=>{ return !_.isNull(v.value);  });
                                    this.obSearch.idCanal = _.get(this.listGeneral,['listCanal','0','value'],null);

                                    return this.onListarSeguro('L');
                        })
                        .catch((e) =>{
                              mensajesAlerta(e, error);
                        });
            },
            watch:{
                  check(val){
                        if(!val){
                              this.obSearch.rangoValorDesde = null;
                              this.obSearch.rangoValorHasta = null;
                        }
                  }
            },
            computed:{
                  isGroup(){
                        return _.size(_.get(this.listGeneral,'detalle',[])) > 0 ? false : false;
                  }
            },
            methods:{
                  onListarSeguro(ev){
                        if(!_.isUndefined(ev)){
                              var error = 'E';
                              var el = _.cloneDeep(this.obSearch);
                              var o = {
                                          opcion:'LISTAR_SEGURO_X_ASEGURADORA_CANAL',
                                          idCanal: _.toNumber(el.idCanal) == 0 ? null : el.idCanal,
                                          idEstado:el.idEstado 
                              };
                              
                              this.disabled = true;
                              this.listGeneral.listSeguro = [];

                              axios.post(`${BASE_URI}administrador/poliza/listar`,o)
                                    .then((r) =>{
                                          if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                          if(_.size(_.get(r,['data','data'],[])) == 0) { error="I"; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion)};
                                                var l = [{ text:'Todos',value:'0' }];
                                                _.map(_.cloneDeep(r.data.data),(v)=>{
                                                      l.push({ value:v.idSeguro, text:v.seguro})
                                                });
                                                this.listGeneral.listSeguro = l;
                                                this.disabled = false;
                                    })
                                    .catch((e) =>{
                                          this.disabled = false;
                                          mensajesAlerta(e, error);
                                    });
                        }
                  },
                  onListarProducto(ev){
                        if(!_.isUndefined(ev)){
                              var error = 'E';
                              var el = _.cloneDeep(this.obSearch);
                              var o = {
                                          opcion:'LISTARCOMBO',
                                          idSeguro: _.toNumber(el.idSeguro) == 0 ? null : el.idSeguro,
                                          idEstado:el.idEstado 
                              };

                              this.disabled = true;
                              this.listGeneral.listProducto = [];

                              axios.post(`${BASE_URI}administrador/producto/listar`,o)
                                    .then((r) =>{
                                          if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                          if(_.size(_.get(r,['data','data'],[])) == 0) { error="I"; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion)};
                                                var l = [{ text:'Todos',value:'0' }];
                                                _.map(_.cloneDeep(r.data.data),(v)=>{
                                                      l.push({ value:v.id_producto,text:v.nombre_producto})
                                                });
                                                this.listGeneral.listProducto = l;
                                                this.disabled = false;
                                    })
                                    .catch((e) =>{
                                          this.disabled = false;
                                          mensajesAlerta(e, error);
                                    });
                        }
                  },
                  onListarCertificados(ev){
                        try {
                              if(!_.isUndefined(ev)){
                                    if(!this.$refs.form.validate()) throw mensajeEstandar.corregirInformacion;
                                          this.disabled = true;
                                          var error = 'E';
                                          var el = _.cloneDeep(this.obSearch);
                                          var o = _.merge(
                                                {
                                                      opcion:'LISTAR',
                                                      idCanal: _.toNumber(el.idCanal) == 0 ? null : el.idCanal,
                                                      idSeguro: _.toNumber(el.idSeguro) == 0 ? null : el.idSeguro,
                                                      idProducto: _.toNumber(el.idProducto) == 0 ? null : el.idProducto,
                                                      isDet:true,
                                                      idEstado:el.idEstado 
                                                },
                                                _.pick(el,['fechaDesde','fechaHasta','rangoValorDesde','rangoValorHasta'])
                                          );
                                          
                                          this.listGeneral.detalle = [];

                                          axios.post(`${BASE_URI}administrador/informe-beneficio-complementario/listar`,o)
                                                .then((r) =>{
                                                      if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                                      if(_.size(_.get(r,['data','data'],[])) == 0) { error="I"; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion)};
                                                            
                                                            var ll = [];
                                                            var l = [];

                                                            _.forEach(_.cloneDeep(r.data.data),(v)=>{
                                                                  ll = _.concat(ll,v);
                                                                  l = _.concat(l,v);
                                                                  
                                                                  ll.push({
                                                                              idProducto:'',
                                                                              producto:_.get(v,'0.producto',null),
                                                                              poliza:'',
                                                                              idCertificado:'',
                                                                              asegurado:'Total',
                                                                              idPoliza:'',
                                                                              prima:this.toCastNumber(this.toSum(v,'prima')),
                                                                              comision:this.toCastNumber(this.toSum(v,'comision')),
                                                                              beneficio:this.toCastNumber(this.toSum(v,'beneficio')),
                                                                              costoAsignado:this.toCastNumber(this.toSum(v,'costoAsignado')),
                                                                              costo:this.toCastNumber(this.toSum(v,'costo')),
                                                                              class:'font-weight-bold',
                                                                  });
                                                            });

                                                            console.info(ll)
                                                            console.info(l)
                                                            this.obTotal = {
                                                                  'totalPrima':this.toCastNumber(this.toSum(l,'prima')),
                                                                  'totalComision':this.toCastNumber(this.toSum(l,'comision')),
                                                                  'totalBeneficio':this.toCastNumber(this.toSum(l,'beneficio')),
                                                                  'totalCosto':this.toCastNumber(this.toSum(l,'costo')),
                                                                  'totalCostoAsignado':this.toCastNumber(this.toSum(l,'costoAsignado')),
                                                            }
                                                            this.listGeneral.detalle = ll;
                                                            // this.listGeneral.detalle = _.remove(l,(v)=>{ return _.size(v.idProducto) > 0 });
                                                            // this.obTotal = _.get(_.remove(l,(v)=>{ return _.size(v.idProducto) == 0 }),'0',{});
                                                            // // console.info(this.obTotal,this.listGeneral.detalle)
                                                            this.disabled = false;
                                                })
                                                .catch((e) =>{
                                                      mensajesAlerta(e, error);
                                                      this.disabled = false;
                                                });
                              }
                        } catch (ex) {
                              mensajesAlerta(ex, 'I');
                        }
                  },
                  toCastNumber(num,n=2){
                        return `$ ${Number.parseFloat(_.round(_.toNumber(num),n)).toFixed(n)}`
                  },
                  toSum(l,key){
                        var s = _.sumBy(l,(v)=>{  return _.toNumber(_.get(v,key,0));  });
                        return _.isNaN(s) ? 0 : s;
                  },
                  ver(v){
                        this.disabled = true;
                        var error = 'E';
                        var o = _.merge({opcion:'L_BENE_X_CER'},_.pick(v,['idCertificado','idPoliza']));

                        this.listGeneral.detalleModal = [];
                        axios.post(`${BASE_URI}administrador/asignacion-beneficio-complementario/listar`,o)
                              .then((r) =>{
                                    if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                    if(_.size(_.get(r,['data','data'],[])) == 0) { error="I"; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion)};
                                          this.obModal = {
                                                open: true,
                                                titulo: `Beneficios de ${v.asegurado}`,
                                                search:''
                                          }
                                          this.listGeneral.detalleModal = r.data.data;
                                          this.disabled = false;
                              })
                              .catch((e) =>{
                                    this.disabled = false;
                                    mensajesAlerta(e, error);
                              });
                  },
                  close(band){
                        this.obModal = {
                              open:band,
                              titulo:'',
                              search:''
                        }
                  }
            },
            provide(){
                  return{
                        close:this.close
                  }
            }
      }
</script>